
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RecommendedEventBadgeProps {
  className?: string;
}

const RecommendedEventBadge: React.FC<RecommendedEventBadgeProps> = ({ className }) => {
  return (
    <Badge 
      variant="secondary" 
      className={cn(
        "absolute top-4 right-4 flex items-center gap-1 bg-yellow-100 text-yellow-800 border border-yellow-300",
        className
      )}
    >
      <Star className="h-3 w-3 fill-yellow-500 text-yellow-500" />
      Ajánlott
    </Badge>
  );
};

export default RecommendedEventBadge;
